export default "/public/img/logo.7dac9420.png";